module.exports = __webpack_public_path__ + "img/about.9af114b6.jpg";